import { Component, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DocumentPreviewComponent } from '../document-preview/document-preview.component';
import { LeasingService } from '../../../core/services/leasing.service';
import { DataService } from '../../../core/services/data.service';
import { ChargingComponent } from '../charging/charging.component';

@Component({
  selector: 'app-upload-document',
  standalone: true,
  imports: [CommonModule, DocumentPreviewComponent, ChargingComponent],
  templateUrl: './upload-document.component.html',
  styleUrls: ['./upload-document.component.scss']
})
export class UploadDocumentComponent {
  @Input() title: string = '';
  @Input() roleName: string = '';
  @Input() isVisible: boolean = false;
  @Input() taskId: number = 0;
  @Input() roleId: number = 0;
  @Output() close = new EventEmitter<void>();
  @Output() documentSaved = new EventEmitter<void>();

  @ViewChild(ChargingComponent) charging!: ChargingComponent;

  selectedFile: File | null = null;
  showPreview: boolean = false;
  isSaving: boolean = false;

  constructor(
    private leasingService: LeasingService,
    private dataService: DataService
  ) {}


onFileSelected(event: any): void {
  const file = event.target.files[0];
  const allowedExtensions = ['jpg', 'jpeg', 'png', 'gif', 'tiff', 'bmp', 'pdf', 'doc', 'docx'];

  if (file) {
    const extension = this.getFileExtension(file.name);
    const isAllowed = allowedExtensions.includes(extension);

    if (isAllowed && file.size <= 1.5 * 1024 * 1024) {
      this.selectedFile = file;
    } else {
      this.selectedFile = null;
      // Aquí podrías mostrar un mensaje de error en la UI
      console.warn('Archivo no permitido o demasiado grande');
    }
  }
}

  closeModal(): void {
    this.selectedFile = null;
    this.close.emit();
  }

  async onSave(): Promise<void> {
    if (!this.selectedFile || this.isSaving) return;

    try {
      this.isSaving = true;
      this.charging.showSpinner('Cargando documento...');
      
      const quotationNumber = this.dataService.getQuotationNumber();
      if (!quotationNumber) throw new Error('No quotation number found');

      const fileContent = await this.fileToBase64(this.selectedFile);
      const fileExtension = this.getFileExtension(this.selectedFile.name);

      const request = {
        strDocumentName: this.selectedFile.name,
        strExtensionFile: fileExtension,
        btFileContent: fileContent,
        inIdDocumentType: this.taskId,
        inIdQuoteHeader: quotationNumber,
        inIdRole: this.roleId
      };

      await this.leasingService.AddQuoteDocument(request).toPromise();
      this.documentSaved.emit();
      this.closeModal();
    } catch (error) {
      console.error('Error saving document:', error);
    } finally {
      this.charging.hideSpinner();
      this.isSaving = false;
    }
  }

  private fileToBase64(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        const base64String = reader.result as string;
        // Eliminar el prefijo "data:*/*;base64," del string
        const base64Content = base64String.split(',')[1];
        resolve(base64Content);
      };
      reader.onerror = error => reject(error);
    });
  }

  private getFileExtension(filename: string): string {
    return filename.split('.').pop()?.toLowerCase() || '';
  }
}